@let isOptionsListOpenSignalValue = isOptionsListOpen();
<div class="typeahead" (clickOutside)="handleClickOutside($event)">
    <div class="typeaheadWrapper" [class.disabled]="false" [formGroup]="form" [ngClass]="{ open: isOptionsListOpenSignalValue }">
        <div class="typeaheadMain">
            <div
                class="selectedOption"
                tabindex="0"
                #selectionContainer
                [class.disabled]="isDisabled()"
                [id]="id"
                (keydown.space)="openOptionsList($event)"
                (keydown.enter)="toggleOptionsListVisibility($event)"
                (mouseup)="toggleOptionsListVisibility($event)"
                (keydown.arrowDown)="moveDown($event)"
                (keydown.arrowUp)="moveUp($event)"
            >
                @if (selectedOption?.label) {
                    <span class="label" [title]="selectedOption?.label || '' | translate">{{
                        selectedOption?.label || '' | translate
                    }}</span>
                } @else if (emptyOptionLabel() && !isDisabled()) {
                    <span class="label placeholder" [title]="emptyOptionLabel() | translate">{{ emptyOptionLabel() | translate }}</span>
                } @else {
                    <span class="label placeholder" [title]="placeholder | translate">{{ placeholder | translate }}</span>
                }
                @if (showClearSelectionButton && selectedOption?.label) {
                    <button
                        title="{{ 'generalKeywords.clearSelection' | translate }}"
                        class="button transparent close small"
                        (keydown.space)="clearSelection($event)"
                        (keydown.enter)="clearSelection($event)"
                        (click)="clearSelection($event)"
                    >
                        <i class="far fa-times inputIcon closeIcon"></i>
                    </button>
                }
                <button class="button small transparent arrow" aria-hidden="true" tabindex="-1">
                    <i class="far fa-sx fa-fw fa-chevron-down inputIcon"></i>
                </button>
            </div>
        </div>

        @if (isOptionsListOpenSignalValue) {
            <div class="typeaheadDropdown" (keydown.tab)="closeOptionsList($event)" (keydown.escape)="closeOptionsList($event)">
                <div class="searchInput">
                    <i class="icon inputIcon prefix far fa-sx fa-fw fa-search" aria-hidden="true"></i>
                    <input
                        type="text"
                        formControlName="searchInput"
                        (keydown.enter)="selectOption()"
                        (keydown.arrowDown)="moveDown($event)"
                        (keydown.arrowUp)="moveUp($event)"
                        #searchInput
                    />
                </div>
                <hr />
                <ul class="optionsList" #dropdownMenu>
                    @if (showEmptyOption && !form.value?.searchInput) {
                        <li
                            class="emptyOption noFixedWidth menuItemAuto"
                            [ngClass]="{ hovered: hoveredItemIndex < 0, selected: selectedOption?.label === '' }"
                            (mousemove)="mouseMove(-1)"
                            (click)="selectOption()"
                            #emptyOption
                        >
                            {{ emptyOptionLabel() | translate }}
                        </li>
                    }
                    @if (isOptionsListOpenSignalValue && filteredOptionsList.length) {
                        @for (option of filteredOptionsList; track option.id; let i = $index) {
                            <li
                                class="noFixedWidth menuItemAuto"
                                #menuItemAuto
                                [title]="option.label || '' | translate"
                                [ngClass]="{ hovered: i === hoveredItemIndex, selected: filteredOptionsList[i] === selectedOption }"
                                [innerHTML]="filteredOptionsList[i].label! | translate | highlight: searchInput.value"
                                (mousemove)="mouseMove(i)"
                                (mouseup)="selectOption(filteredOptionsList[i])"
                                (keydown.enter)="selectOption(filteredOptionsList[i])"
                            >
                                {{ option.label | translate }}
                            </li>
                        }
                    } @else {
                        <li class="noFixedWidth menuItemAuto">
                            <span class="label">{{ 'multiselect.noOptions' | translate }}</span>
                        </li>
                    }
                </ul>
            </div>
        }
    </div>
</div>
